module.exports = __webpack_public_path__ + "img/background-main-new.56782bbd.svg";